import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { storeManagementApi, Marks } from '@services/api'

export const fetchStoreMarks = createAsyncThunk(
  'storeMarks/fetchStoreMarks',
  async (params: any) => {
    const response = storeManagementApi.fetchStoreMarks(params)
    return response
  }
)

export const fetchAllMarks = createAsyncThunk(
  'storeMarks/fetchAllMarks',
  async () => {
    const response = await Marks.fetchAllMarks()
    return response
  }
)

export const download = createAsyncThunk(
  'storeMarks/download',
  async (params: any) => {
    const response = await storeManagementApi.downloadStoreMarks(params)
    return response
  }
)

export const upload = createAsyncThunk(
  'storeMarks/upload',
  async (formData: FormData) => {
    const response = await storeManagementApi.uploadStoreMarks(formData)
    return response
  }
)

export const updateStoreMarks = createAsyncThunk(
  'storeMarks/update',
  async (data: any) => {
    const response = await storeManagementApi.updateStoreMarks(data)
    return response
  }
)

const initialState = {
  allMarks: [] as any[],
  storeList: [] as any[],
  selectedStore: {},
  pageIndex: 1,
  pageSize: 10,
  totalPage: 0,
  totalRecords: 0,
  storeCD: '',
  storeName: '',
  markId: '',
  isDownloading: false,
  isUploading: false
}

const storeMarksSlice = createSlice({
  name: 'storeMarks',
  initialState,
  reducers: {
    selectStore: (state, action) => {
      state.selectedStore = action.payload
    },
    setStoreCD: (state, action) => {
      state.storeCD = action.payload
    },
    setStoreName: (state, action) => {
      state.storeName = action.payload
    },
    setMarkId: (state, action) => {
      state.markId = action.payload
    },
    setIsUploading: (state, action) => {
      state.isUploading = action.payload
    },
    setIsDownloading: (state, action) => {
      state.isDownloading = action.payload
    },
    setMark: (state, action) => {
      if (!state.storeList[action.payload.storeIndex].newMarkIds) {
        state.storeList[action.payload.storeIndex].newMarkIds = [...state.storeList[action.payload.storeIndex].markIds]
      }

      state.storeList[action.payload.storeIndex].newMarkIds[action.payload.index] = action.payload.markId
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchStoreMarks.fulfilled, (state, action) => {
      state.storeList = action.payload.data
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalPage = action.payload.totalPage
      state.totalRecords = action.payload.totalRecords
    })
    builder.addCase(fetchAllMarks.fulfilled, (state, action) => {
      state.allMarks = action.payload.data
    })
  }
})

export const {
  selectStore,
  setStoreCD,
  setStoreName,
  setMarkId,
  setIsDownloading,
  setIsUploading,
  setMark
} = storeMarksSlice.actions

export default storeMarksSlice.reducer
